/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { withStateHandlers } from '../../utils/hoc';

const withModal = withStateHandlers(
  { modalOpen: false, modalValue: undefined },
  {
    toggle: ({ modalOpen }) => (value) => ({
      modalOpen: !modalOpen,
      modalValue: modalOpen ? undefined : value // If open then reset value when closing
    }),
    open: () => (value) => ({
      modalOpen: true,
      modalValue: value
    }),
    close: () => () => ({
      modalOpen: false,
      modalValue: undefined
    })
  }
);

export default withModal;
